module.exports = __webpack_public_path__ + "static/media/city.f6569ac7.png";